import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import HeaderBottom from '../../components/HomePage/HeaderBottom';

const FAQtextEditTwo = () => {

    const [faqTextTwo, setService] = useState([]);
    const { id } = useParams();


    useEffect(() => {
        fetch(`https://ai-automation-audit-01-e0855711738d.herokuapp.com/faq-two/${id}`)
            .then((res) => res.json())
            .then((info) => setService(info));
    }, []);




    const handlefaqTextTwo = (event) => {
        event.preventDefault();
        const faqTextTwo = event.target.faqTextTwo.value;
        const faqHeadingTwo = event.target.faqHeadingTwo.value;
        const faqImageTwo = event.target.faqImageTwo.value;



        const faqSection = {
            faqTextTwo,
            faqHeadingTwo,
            faqImageTwo,


        };

        const url = `https://ai-automation-audit-01-e0855711738d.herokuapp.com/faq-two/${id}`;
        fetch(url, {
            method: "PUT",
            headers: {
                "content-type": "application/json",
            },
            body: JSON.stringify(faqSection),
        })
            .then((res) => res.json())
            .then((result) => {

                alert(' FAQ Text is Updated');
            });
    };




    return (
        <>
            <HeaderBottom></HeaderBottom>
            {
                <section id="services" className="services-area  vh-100">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-8 col-md-12 text-center">
                                <h3>Update FAQ Text</h3>

                                <form className="contact-form" onSubmit={handlefaqTextTwo}>
                                    <div className="row justify-content-center">
                                        <div className="col-lg-12">
                                            <div className="contact-field p-relative c-name ">
                                                <input
                                                    className="form-control form-control-lg shadow-lg p-3 mb-3 bg-white rounded"
                                                    name="faqTextTwo"
                                                    defaultValue={faqTextTwo.faqTextTwo}
                                                    placeholder="FAQ Text"
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <div className="col-lg-12">
                                            <div className="contact-field p-relative c-name ">
                                                <input
                                                    className="form-control form-control-lg shadow-lg p-3 mb-3 bg-white rounded"
                                                    name="faqHeadingTwo"
                                                    defaultValue={faqTextTwo.faqHeadingTwo}
                                                    placeholder="FAQ Heading"
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-12">
                                            <div className="contact-field p-relative c-name ">
                                                <input
                                                    className="form-control form-control-lg shadow-lg p-3 mb-3 bg-white rounded"
                                                    name="faqImageTwo"
                                                    defaultValue={faqTextTwo.faqImageTwo}
                                                    placeholder="FAQ Image"
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <div className="slider-btn text-center">
                                            <button
                                                className="theme-btn btn-one"
                                                data-animation="fadeInRight"
                                                data-delay=".8s"
                                            >
                                                Update FAQ Text
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </section>
            }
        </>
    );
};

export default FAQtextEditTwo;